import * as constants from '../constants';

const initialState = [];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getAgrotechnicalEventsAccounting.success: {
            return action.payload.results;
        }

        case constants.getAgrotechnicalEventsAccounting.error: {
            return initialState;
        }

        default:
            return state;
    }
}
